var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-4"},[_vm._v(" "+_vm._s(_vm.counter / _vm.items.length)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }